import Swiper, { Autoplay, Navigation } from "swiper";

let featuredResources;
const swiperParent = document.querySelector(".resources-featured__list .swiper-swiper");

if (swiperParent) {
  const swiperWrapper = document.querySelector(".resources-featured__list .swiper-swiper-wrapper");
  const swiperItems = document.querySelectorAll(".resources-featured__list .swiper-swiper-slide");

  function initSwiper() {
    const screenWidth = window.innerWidth;
    if (screenWidth < 1024 && featuredResources === undefined) {
      swiperParent.classList.add("swiper");
      swiperWrapper.classList.add("swiper-wrapper");
      swiperItems.forEach((e) => e.classList.add("swiper-slide"));

      featuredResources = new Swiper(".resources-featured__list .swiper", {
        modules: [Autoplay, Navigation],
        autoplay: {
          delay: 5000,
        },
        slidesPerView: 1.35,
        spaceBetween: 20,
        navigation: {
          nextEl: ".resources-featured__list .next",
          prevEl: ".resources-featured__list .prev",
        },
      });
    } else if (screenWidth >= 1024 && featuredResources !== undefined) {
      featuredResources.destroy();
      featuredResources = undefined;
      swiperParent.classList.remove("swiper");
      swiperWrapper.removeAttribute("style");
      swiperWrapper.classList.remove("swiper-wrapper");

      swiperItems.forEach((e) => e.classList.remove("swiper-slide"));
    }
  }

  initSwiper();

  window.addEventListener(
    "resize",
    function (event) {
      initSwiper();
    },
    true
  );
}
